import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { ProductService } from '../../core/http/apiProduct/product.service';
import { QuotationService } from '../../core/http/apiPricing/quotation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ContratarService } from '../../core/http/apiPayment/contratar.service';
import { ConsentimientosDataDto, ContratacionDataDto, CotizacionDataDto, PersonaDataDto, WizardDTO } from './models/wizard.model';
import moment from 'moment';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { ConfirmDialogComponent } from '../../shared/dialog/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { CoverageModalBaseComponent } from '../../shared/coverage-modal-base/coverage-modal-base.component';
import { environment } from '../../../environments/environment';
import { AxerveSharedResponseDTO } from '../../core/http/apiPayment/models/AxerveSharedResponseDTO';
import { IPaymentFlow3D2SRedirectData } from './models/IPaymentFlow3DS2RedirectData';
import { PolicyService } from '../../core/http/apiPolicy/policy.service';
import { AnalyticsService } from '../../core/services/adobe-analytics/analytics.service';
import { Utils } from '../../shared/utils/utils';
import { Meta, Title } from '@angular/platform-browser';

const AXERVE_ERROR_RESPONSE: string = "0";
const PAYMENT_ERRORS_CODES: string[] = ["0", "", "8006"];

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {

  textListInfo: string[] = [];
  data: any[] = [];
  aliasProduct: string = "InfProduct";
  productName: string;
  currentStep: number = 1;
  idProducto: string = "";
  paymentFormData: any;
  formData: any;
  aliasProducto: string;
  wizardDTO: WizardDTO = new WizardDTO
  htmlConsents: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pantallasService: ProductService,
    private cotizacionService: QuotationService,
    private contratarService: ContratarService,
    private policyService: PolicyService,
    private spinnerService: SpinnerService,
    private dialog: MatDialog,
    private analyticsService: AnalyticsService,
    private titleService: Title,
    private metaService: Meta,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';

    this.wizardDTO.cotizacion = new CotizacionDataDto();
    this.wizardDTO.persona = new PersonaDataDto();
    this.wizardDTO.payment = new ContratacionDataDto();
    this.wizardDTO.consentimientos = new Array<ConsentimientosDataDto>();
    this.spinnerService.show();
  }

  ngOnInit(): void {
    this.analyticsService.resetDataLayer();
    this.activatedRoute.params.subscribe(_ => {
      const params = this.activatedRoute.snapshot.queryParams;
      const r3ds2 = { ...params } as IPaymentFlow3D2SRedirectData;

      if (!!r3ds2.a) {
        this.handleR3ds2Redirect(r3ds2);
        return;
      }
      this.aliasProducto = this.activatedRoute.snapshot.params['aliasProducto'];
      this.setupSEO(this.aliasProducto);
      this.getIdConsentByProductAlias(this.aliasProducto);
      this.getScreenData();
      this.getProductDescription();
    });
  }

  private setupSEO(aliasProducto: string): void {
    const seoConfig: Record<string, { title: string; description: string }> = {
      noasistviajeanual: {
        title: 'Seguro de cancelación de viajes anual | ingood by Reale',
        description: 'Seguro de cancelación de viajes anual de ingood by Reale. Recupera el dinero de vuelos, trenes, hoteles y reservas en minutos',
      },
      noasistanual: {
        title: 'Seguro de cancelación de entradas anual | ingood by Reale',
        description: 'Seguro de cancelación de entradas anual de ingood by Reale. Recupera el dinero de cualquier evento al que no puedas ir en minutos',
      },
    };

    const config = seoConfig[aliasProducto.toLowerCase()];
    if (!config) return;

    this.titleService.setTitle(config.title);
    this.metaService.updateTag({ name: 'description', content: config.description });
  }

  nextStep() {
    this.currentStep++;
  }

  handleR3ds2Redirect(r3ds2: IPaymentFlow3D2SRedirectData) {
    this.currentStep = 3;

    if (r3ds2.Status === "KO") {
      this.spinnerService.hide();
      this.analyticsService.onReady().pipe(take(1)).subscribe(() => this.openErrorDialog());
      return
    }
    const status = r3ds2.Status;
    const paymentId = r3ds2.paymentID;
    const paymentToken = r3ds2.paymentToken;
    const transactionId = sessionStorage.getItem('transactionId') ?? '';
    const quotationId = sessionStorage.getItem('quotationId') ?? '';
    const cvv = sessionStorage.getItem('cvv') ?? '';
    const cardNumber = sessionStorage.getItem('cardNumber') ?? '';
    const expMonth = sessionStorage.getItem('expMonth') ?? '';
    const expYear = sessionStorage.getItem('expYear') ?? '';
    const idPersona = sessionStorage.getItem('idPersona') ?? '';
    const idFraccionPago = sessionStorage.getItem('idFraccionPago') ?? '';
    var idPoliza = '';

    var validate3ds2 = {
      "idTransaction": transactionId,
      "paymentId": paymentId,
      "paymentToken": paymentToken,
      "status": status,
      "listCotizaciones": [
        quotationId
      ],
      "idPersona": idPersona,
      "idFraccionPago": idFraccionPago,
      "paymentGeneral": {
        "cvv": cvv,
        "expMonth": expMonth,
        "expYear": expYear,
        "number": cardNumber
      }
    }

    this.contratarService.contratarFinal(validate3ds2).subscribe({
      next: (resp: any) => {
        this.spinnerService.hide();
        const idPoliza = resp?.data?.idPoliza;
        sessionStorage.setItem('idPoliza', idPoliza);
        sessionStorage.setItem('policyData', JSON.stringify({ idPoliza }));
        sessionStorage.removeItem('personalForm');
        this.openConfirmDialog();
      },
      error: (error: any) => {
        console.log('Error al contratar final', error);
        this.spinnerService.hide();
      }
    });

    // TODO: Actualizar datos de la transacción.

    //  // Obtenemos los detalles de la transaccion para verificar si ha terminado correctamente ya que
    //  // en caso de error, no sabemos el motivo al redireccionar de vuelta
    //  this.operacionCobroService.paymentGatewayDetail(transactionId, paymentId, paymentToken).subscribe(detailResponse => {
    //    if (r3ds2.Status === "OK") {
    //      console.log("Contratando", detailResponse);
    //      this.contratarBundles(transactionId, paymentId, paymentToken);
    //    } else {
    //      console.log("Reportando error en transaccion", detailResponse);
    //      this.openErrorsDialog([detailResponse.data.payload.transactionErrorDescription], true);
    //    }
    //  })
    //}
  }

  goBackStep(step: number) {
    this.currentStep = step;
  }

  getData(idProducto: string, productName: string) {
    this.cotizacionService.getCotizacionByIdProducto(idProducto, productName)?.subscribe({
      next: (res: any) => {
        this.spinnerService.hide();
        this.data = res.data
        this.wizardDTO.cotizacion = res.data
        sessionStorage.setItem('quotationId', res.data.idCotizacion);
      },
      error: (error: any) => {
        console.log('Error al obtener la cotizacion', error);
      }
    });
  }

  getScreenData(): void {
    this.pantallasService.getPantallas(this.aliasProduct, this.aliasProducto).subscribe((res: any) => { this.textListInfo = res[1] })
  }

  getProductDescription(): void {
    this.pantallasService
      .getDescripcionProductoByAlias(this.aliasProducto)
      .subscribe((res: any) => {
        if (res?.data?.descripcion) {
          this.productName = res.data.descripcion.charAt(0).toUpperCase() + res.data.descripcion.slice(1).toLowerCase();
          sessionStorage.setItem('productDescription', this.productName);
        }
        this.getData(this.aliasProducto, this.productName ?? '');
      });
  }


  doPayment() {
    this.spinnerService.show();
    if (!this.wizardDTO) {
      console.error('Faltan datos para ejecutar el pago');
    }
    this.contratarService.contratar(this.wizardDTO).subscribe({
      next: (resp: AxerveSharedResponseDTO) => {
        this.handleAxerveResponse(resp);
      },
      error: (error: any) => {
        console.log('Error al obtener la cotizacion', error);
      }
    });
  }

  handleAxerveResponse(resp: AxerveSharedResponseDTO) {
    if (resp.data.error.code != AXERVE_ERROR_RESPONSE || !PAYMENT_ERRORS_CODES.includes(resp.data.payload.transactionErrorCode)) {
      console.error("Error while checking the payment response. No redirect will be perform.");
      return;
    }

    let hrefRedirect = resp.data.payload.userRedirect.href;

    sessionStorage.setItem('transactionId', resp.data.idTransaccion ?? '');
    sessionStorage.setItem('idPersona', resp.data.idPersona ?? '');
    sessionStorage.setItem('idFraccionPago', resp.data.idFraccionPago ?? '');

    this.spinnerService.hide();

    if (resp.data.payload.transactionErrorCode === "8006") {
      window.location.href = hrefRedirect;
    }
    else {
      var param: IPaymentFlow3D2SRedirectData = {
        Status: "OK",
        idTransaccion: resp.data.idTransaccion || "",
        paymentID: resp.data.payload.paymentID,
        paymentToken: resp.data.payload.paymentToken,
        a: "test"
      };

      this.handleR3ds2Redirect(param);
    }

  }

  handlePayment(data: any) {
    var expMonth = moment(data.expiryDate).format('MM').toString();
    var expYear = moment(data.expiryDate).format('YY').toString();
    if (this.wizardDTO.persona.dni != null || this.wizardDTO.persona.dni != undefined) {
      sessionStorage.setItem('wizardDTO', JSON.stringify(this.wizardDTO));
    }

    this.wizardDTO = JSON.parse(sessionStorage.getItem('wizardDTO') ?? '');
    this.wizardDTO.payment.cvv = data.cvv;
    this.wizardDTO.payment.number = data.cardNumber;
    this.wizardDTO.payment.expMonth = expMonth;
    this.wizardDTO.payment.expYear = expYear;

    sessionStorage.setItem('cvv', data.cvv);
    sessionStorage.setItem('cardNumber', data.cardNumber);
    sessionStorage.setItem('expMonth', expMonth);
    sessionStorage.setItem('expYear', expYear);

    this.doPayment()
  }


  handleFormData(data: any) {

    const apellidosArray = data.apellidos.trim().split(' ');
    const apellido1 = apellidosArray[0] || '';
    const apellido2 = apellidosArray.slice(1).join(' ') || ''

    const direccion = data.direccion;
    const cpMatch = direccion.match(/\b\d{5}\b/);
    const codigoPostal = cpMatch ? cpMatch[0] : '';
    const municipio = JSON.parse(sessionStorage.getItem('direccion') || '{}').municipio || '';

    this.wizardDTO.persona.dni = data.dni
    this.wizardDTO.persona.nombre = data.nombre
    this.wizardDTO.persona.apellidos = data.apellidos
    this.wizardDTO.persona.apellido1 = apellido1
    this.wizardDTO.persona.apellido2 = apellido2
    this.wizardDTO.persona.direccion = data.direccion
    this.wizardDTO.persona.cp = codigoPostal
    this.wizardDTO.persona.municipio = municipio
    this.wizardDTO.persona.telefono = data.Telefono
    this.wizardDTO.persona.email = data.Email
    this.wizardDTO.persona.fechaNacimiento = moment(data.fechaNacimiento).toISOString();
  }

  openConfirmDialog() {

    const dialogConfig = {
      disableClose: true,
      panelClass: 'clientFinishDialog-panel',
      data: {
        title: '¡Todo listo!',
        subtitle: 'A partir de ahora tus emociones están aseguradas con ingood. Inicia sesión y gestiona tu póliza desde el área privada',
        icon: 'check-circle',
        buttonText: 'Iniciar sesión',
        showCancelButton: true
      },
    };

    this.set_initial_analytics_config('click-button:payment',
      'imPageview',
      'app_cotizador:area_publica:sales:creditcardPayment',
      'insuranceIsActive',
      'sales_insuranceIsActive',
      '15',
      'completado');
    this.analyticsService.startEventsWithCallback('imPageview', () => {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
      this.set_initial_analytics_config('click-button:payment',
        'SalesPFinal',
        'app_cotizador:area_publica:sales:insuranceIsActive',
        'creditcardPayment',
        'sales_creditcardPayment',
        '15',
        'resumen');
      this.analyticsService.startEventWithCallback('SalesPFinal', () => {
        sessionStorage.clear();
        dialogRef.afterClosed().subscribe(_ => {

          window.location.href = environment.baseUrlRedirect + '/userAdmin';
        });
      });
    });
  }


  openDesktopModal() {
    this.dialog.open(CoverageModalBaseComponent, {
      width: '44%',
      height: '98vh',
      data: {
        coverageList: {
          alias: 'InfCob1Det1',
          aliasProduct: this.aliasProduct
        },
        coverageDet: {
          alias: 'InfCob1Det2',
          aliasProduct: this.aliasProduct
        }
      },
      panelClass: 'custom-mat-dialog'
    });
  }

  openErrorDialog() {
    const dialogConfig = {
      disableClose: true,
      panelClass: 'clientFinishDialog-panel',
      data: {
        title: 'Vaya...',
        subtitle: 'Ha ocurrido un error en el proceso de pago. Por favor vuelva a intentarlo más tarde.',
        icon: 'sad-face',
        buttonText: 'Aceptar',
        showCancelButton: true
      },
    }

    this.set_initial_analytics_config('click-button:payment:abrir_pagina_payment',
      'imPageview',
      'app_cotizador:area_publica:sales:creditcardPayment:error',
      'creditcardPayment',
      'sales_creditcardPayment_error',
      '13',
      'resumen');
    this.analyticsService.startEventsWithCallback('imPageview', () => {
      this.dialog.open(ConfirmDialogComponent, dialogConfig);
    });
  }

  getIdConsentByProductAlias(aliasProduct: string) {
    this.policyService.getIdConsentByProductAlias(aliasProduct).subscribe({
      next: (resp: any) => {
        if (resp?.data?.consentimientosResponseList?.length > 0) {
          resp.data.consentimientosResponseList.forEach((consentimiento: any) => {
            this.wizardDTO.consentimientos.push({
              idConsentimiento: consentimiento.idConsent,
              aceptar: true
            });
            this.htmlConsents = consentimiento.descripcionCortaHTML;
          });
        } else {
          console.warn('No se encontraron consentimientos para este producto.');
        }
      },
      error: (error: any) => {
        console.error('Error al traer consentimientos', error);
      }
    });
  }

  /**
    * Set all the analytics' related info for the current component
  */
  private set_initial_analytics_config(categoryActionLabel: string,
    eventName: string,
    pageName: string, familySelection:
      string, processName: string,
    processStep: string,
    processStatus: string): void {
    this.analyticsService.resetDataLayer();
    const sessionData = this.getAnalyticsDataFromSession();
    /* ===================== */
    /* PAGE DATA */
    /* ===================== */
    this.analyticsService.setPhysicalUrl(environment.baseUrl + sessionData.aliasProducto);
    this.analyticsService.setPageName(pageName);
    this.analyticsService.setPageContentType('cotizador');
    this.analyticsService.setPageDigitalChannel('app_cotizador');
    this.analyticsService.setPageSection('area_publica');
    this.analyticsService.setPageLanguage('es');
    this.analyticsService.setNivel1('sales');
    this.analyticsService.setNivel2(familySelection);
    /* ===================== */
    /* PROCESS DATA */
    /* ===================== */
    this.analyticsService.setProcessStep(processStep);
    this.analyticsService.setProcessType('sales');
    this.analyticsService.setProcessName(processName);
    this.analyticsService.setProcessStatus(processStatus);

    /* ===================== */
    /* USER DATA */
    /* ===================== */
    this.analyticsService.setUserStatus('no_logado');
    this.analyticsService.setUserLang('es');
    const personalFormData = sessionStorage.getItem('personalForm');
    let userBirth = '';
    if (personalFormData) {
      try {
        const parsed = JSON.parse(personalFormData);
        userBirth = parsed.fechaNacimiento ?? '';
      } catch (err) {
        console.warn('Error parsing personalForm from sessionStorage', err);
      }
    }

    this.analyticsService.setUserBirth(userBirth);
    this.analyticsService.setUserResidence('VERDADERO');

    /* ===================== */
    /* PRODUCT DATA (DINÁMICO) */
    /* ===================== */

    this.analyticsService.setFamilySelection(familySelection);
    this.analyticsService.setCategoryActionLabel(categoryActionLabel);
    this.analyticsService.setProductName(Utils.sanitizeString(sessionData.productName));
    this.analyticsService.setProductType(Utils.sanitizeString(sessionData.productType));
    this.analyticsService.setProductArea(sessionData.productArea);
    this.analyticsService.setProductDate(Utils.getProductDate());

    const productCostStart = sessionData.productCostStart;
    const productCostUpgrades = sessionData.productCostUpgrades;
    this.analyticsService.setProductCostStart(productCostStart);
    this.analyticsService.setProductCostUpgrades(productCostUpgrades);

    /* ===================== */
    /* PAYMENT */
    /* ===================== */

    const quotationId = sessionStorage.getItem('quotationId') ?? '';
    this.analyticsService.setIDPresupuesto(quotationId);
    this.analyticsService.setProductPayment('Anual (' + sessionData.productCostStart + ' €/año)');
    this.analyticsService.setProductPaymentType('Cliente con Tarjeta');
    const idPoliza = sessionStorage.getItem('idPoliza') ?? 0;
    this.analyticsService.setIDPoliza(idPoliza.toString());

  }

  private getAnalyticsDataFromSession(): any {
    const stored = sessionStorage.getItem('analyticsData');
    if (!stored) return null;
    return JSON.parse(stored);
  }

}
